import styled from 'styled-components'
import { ColorInterface, NoData, SmallCard, Title } from '../StatisticsPage'
import SingleStackedBar from './SingleStackedBar'
import { useTranslation } from '../../../../../hooks'

const Color = styled.div<ColorInterface>`
    background-color: ${({ color }) => color};
    border-radius: 50%;
    border: none;
    width: 1rem;
    height: 1rem;
    margin: 0.2em 0.5rem 0;
`

const Font14 = styled.p`
    font-size: 1.4rem;
`

const Legend = styled.div`
    display: flex;
    margin: 0 0 1rem;
    justify-content: center;
`

const FieldWrap = styled.div`
    display: flex;
    margin: 0 1rem;
`

interface CaseTypeSplitData {
    anonymous: number
    confidential: number
}

interface AnonymousConfidentialProps {
    caseTypeSplit: CaseTypeSplitData
    hasCases: boolean
}

const AnonymousConfidential = ({
    caseTypeSplit,
    hasCases,
}: AnonymousConfidentialProps) => {
    const translation = useTranslation()

    return (
        <SmallCard justifyContent="space-between">
            <Title>{translation.statisticsPage.anonymousVsConfidential}</Title>
            {hasCases ? (
                <>
                    <SingleStackedBar
                        value1={caseTypeSplit.anonymous}
                        value2={caseTypeSplit.confidential}
                    />
                    <Legend>
                        <FieldWrap>
                            <Color color="#B0C1C7" />
                            <Font14>{translation.reusable.anonymous}</Font14>
                        </FieldWrap>
                        <FieldWrap>
                            <Color color="#849BB5" />
                            <Font14>
                                {translation.newCaseFlow.confidential}
                            </Font14>
                        </FieldWrap>
                    </Legend>
                </>
            ) : (
                <NoData>{translation.statisticsPage.noData}</NoData>
            )}
        </SmallCard>
    )
}

export default AnonymousConfidential
